// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { PauseCircle } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconPauseCircle(props: any) {
    return <IconBase icon={PauseCircle} {...props} />
  }

  export default IconPauseCircle
  